import { Injectable } from '@angular/core';
import { WijmoAutoSaveService } from './wijmo-auto-save.service';
import { appState } from '../store/appstate';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor( private _WijmoAutoSaveService: WijmoAutoSaveService) { }
  setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  getLocalStorage(key) {
        return localStorage.getItem(key);
  }
  removedLocalStorage(key) {
    localStorage.removeItem(key);
  }
  setSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  getSessionStorage(key) {
    return sessionStorage.getItem(key);
  }
  removedSessionStorage(key) {
    sessionStorage.removeItem(key);
  }
  storeWijmoGridDataInSession(flex, count?, wijmokey?) {
    const gridData = flex?.columns?.map(column => ({
      header: column.header,
      width: column.width,
      isVisible: column.isVisible,
      minWidth: column.minWidth
    }));
    if (wijmokey) {
      const storeKey = `applyDefault_${wijmokey}`;
      appState[storeKey] = "false";
    }
    this.setSessionStorage(`flexGridData_${count ? count : "0"}`, gridData);
    this.setSessionStorage(`clientWidth_${count ? count : "0"}`, flex["_e"].clientWidth);
  }
  getWijmoGridDataInSession(wjHeaders, key, count?, applyNewChecks?: boolean) {
    let wijmoSavedWidths = this.getSessionStorage(`flexGridData_${count ? count : "0"}`);
    let clientWidth = this.getSessionStorage(`clientWidth_${count ? count : "0"}`);
    const storeKey = `applyDefault_${key}`;
    if (!applyNewChecks || (applyNewChecks && appState[storeKey] === "false")) {
      if (wijmoSavedWidths) {
          this._WijmoAutoSaveService.storeWijimoStatus( JSON.parse(wijmoSavedWidths) ,key, wjHeaders, clientWidth);
      }
      appState[storeKey] = "";
    }
    if (wijmoSavedWidths) {
      this.removedSessionStorage(`flexGridData_${count ? count : "0"}`);
      this.removedSessionStorage(`clientWidth_${count ? count : "0"}`);
    }
  }
  getSafeLocalStorage(key: string, storage: Storage = localStorage): string | null {
    try {
      if (typeof window !== 'undefined' && storage) {
        return storage.getItem(key);
      }
    } catch (err) {
      console.warn(`Storage getItem failed for key "${key}":`, err);
    }
    return null;
  }

  setSafeLocalStorage(key: string, value: string, storage: Storage = localStorage): boolean {
    try {
      if (typeof window !== 'undefined' && storage) {
        storage.setItem(key, value);
        return true;
      }
    } catch (err) {
      console.warn(`Storage setItem failed for key "${key}":`, err);
    }
    return false;
  }

  removeSafeLocalStorage(key: string, storage: Storage = localStorage): void {
    try {
      if (typeof window !== 'undefined' && storage) {
        storage.removeItem(key);
      }
    } catch (err) {
      console.warn(`Storage removeItem failed for key "${key}":`, err);
    }
  }
}
